export default __webpack_public_path__ + "static/media/statisticThree.ac71ad58.svg";